import React, { useState } from 'react';

const FILE_TYPES = [
  {
    id: 'jobs',
    label: 'Open Jobs',
    filename: 'OPEN_JOBS.xlsx',
    description: 'SCM Profit — Open Jobs report',
    color: '#0e7c7b',
  },
  {
    id: 'jobsHistory',
    label: 'Job History',
    filename: 'JOB_HISTORY.xlsx',
    description: 'SCM Profit — All jobs (3-month export)',
    color: '#7c3aed',
  },
  {
    id: 'ar',
    label: 'AR Aging',
    filename: 'AR_AGING.xlsx',
    description: 'Tally — Sundry Debtors aging export',
    color: '#ef4444',
  },
];

export default function FileUpload({ entity, onFiles, onClose }) {
  const [loaded, setLoaded] = useState({});
  const [dragging, setDragging] = useState(false);

  const processFile = (file, typeHint) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const buffer = new Uint8Array(e.target.result);

      let type = typeHint;
      if (!type) {
        const name = file.name.toUpperCase();
        if (name.includes('HISTORY') || name.includes('ALL_JOB') || name.includes('JOB_DETAIL')) type = 'jobsHistory';
        else if (name.includes('JOB') || name.includes('SCM')) type = 'jobs';
        else if (name.includes('AR') || name.includes('DEBTOR') || name.includes('AGING')) type = 'ar';
        else type = 'jobs';
      }

      setLoaded(prev => ({ ...prev, [type]: file.name }));
      onFiles(entity, [{ type, buffer }]);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    Array.from(e.dataTransfer.files).forEach(f => processFile(f, null));
  };

  const entityLabel = entity === 'uae' ? '🇦🇪 UAE' : '🇸🇦 Saudi';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Upload Data — {entityLabel}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <p className="upload-instruction">
            Drop files below or click each box to upload. Files are processed locally — nothing is sent to any server.
          </p>

          <div className="upload-boxes">
            {FILE_TYPES.map(ft => (
              <div
                key={ft.id}
                className={`upload-box ${loaded[ft.id] ? 'loaded' : ''}`}
                style={{ borderColor: loaded[ft.id] ? ft.color : '#e2e8f0' }}
                onClick={() => {
                  const input = document.createElement('input');
                  input.type = 'file';
                  input.accept = '.xlsx,.xls,.csv';
                  input.onchange = (e) => {
                    if (e.target.files[0]) processFile(e.target.files[0], ft.id);
                  };
                  input.click();
                }}
              >
                <div className="upload-box-icon" style={{ color: ft.color }}>
                  {loaded[ft.id] ? '✓' : '↑'}
                </div>
                <div className="upload-box-label">{ft.label}</div>
                <div className="upload-box-filename">{ft.filename}</div>
                <div className="upload-box-desc">{ft.description}</div>
                {loaded[ft.id] && (
                  <div className="upload-box-loaded">✓ {loaded[ft.id]}</div>
                )}
              </div>
            ))}
          </div>

          <div
            className={`drop-zone ${dragging ? 'dragging' : ''}`}
            onDragOver={e => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={handleDrop}
          >
            <span className="drop-icon">📂</span>
            <span>Or drag and drop all files here — auto-detected by filename</span>
          </div>

          <div className="upload-footer">
            <p className="upload-note">
              Auto-detected: "HISTORY/ALL_JOB/JOB_DETAIL" → Job History · "JOB/SCM" → Open Jobs · "AR/DEBTOR/AGING" → AR Aging
            </p>
            <button
              className="btn-primary"
              disabled={Object.keys(loaded).length === 0}
              onClick={onClose}
            >
              Done ({Object.keys(loaded).length} file{Object.keys(loaded).length !== 1 ? 's' : ''} loaded)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
